import { useState } from "react";
import CatalogAuth from "../components/auth/CatalogAuth";
// In your CatalogInit.jsx or similar
const CatalogInit = () => {
  const [showCatalogAuth, setShowCatalogAuth] = useState(true);

  if (showCatalogAuth) {
    return (<>
    <div className="p-4 w-full">
    <CatalogAuth onBack={() => setShowCatalogAuth(false)} />
    </div>
    </>
    )
    ;
  }
};

export default CatalogInit;